import 'summernote/dist/summernote-lite'; // ne pas prendre la lib de bootstrap 5  !!!!!!
import 'summernote/dist/summernote-lite.css';  // optional if you have css loader

export default class Summernote extends HTMLDivElement {
    constructor() {
        super();

        this.summernoteElement = this.querySelector('textarea');
    }

    connectedCallback() {
        var options_default = {
                toolbar: [
                    // [groupName, [list of button]]
                    ['style', ['style']],
                    ['fontstyle', ['bold', 'italic', 'underline', 'clear']],
                    ['fontname', ['fontname']],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['height', ['height']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture']],
                ],
                height: 250,
                disableDragAndDrop: true,
                lang: 'fr-FR',

            }
        ;

        this.initSummernoteItem($(this.summernoteElement), options_default);
    }

    configSummernote($selector, default_options) {
        /*On ecrase la configuration par defaut si les dataset sont defined */
        if ($selector.data('customtoolbaroptions') != undefined) {
            default_options.toolbar = $selector.data('customtoolbaroptions');
        }

        if ($selector.data('placeholder') != undefined) {
            default_options.placeholder = $selector.data('placeholder');
        }

        $selector.summernote(default_options);

        if ($selector.data('disabled') != undefined) {
            $selector.summernote('disable');
        }
    }

    initSummernoteItem($selector, options) {
        this.configSummernote($selector, options);
    }
}


